import { render, staticRenderFns } from "./DeleteSubjectModal.vue?vue&type=template&id=200cc7d4"
import script from "./DeleteSubjectModal.vue?vue&type=script&lang=js"
export * from "./DeleteSubjectModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteSubjectModal.vue?vue&type=style&index=0&id=200cc7d4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200cc7d4')) {
      api.createRecord('200cc7d4', component.options)
    } else {
      api.reload('200cc7d4', component.options)
    }
    module.hot.accept("./DeleteSubjectModal.vue?vue&type=template&id=200cc7d4", function () {
      api.rerender('200cc7d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/DeleteSubjectModal.vue"
export default component.exports